import React, { useState } from "react";

import fetch from "isomorphic-fetch";
import { withFormik } from "formik";
import qs from 'qs';
import { translate } from "react-i18next";
import CompleteIcon from "react-icons/lib/fa/check";

import { compose } from "recompose";
import validate from "validate.js";

import { Flex, Form } from "src/components";
import { Button, Input } from "src/components/Form";
import { colors } from "src/styles";

const subscriptionUrl = "https://editor.ne16.com/Subscribe/Subscribe.ashx";
const subscriptionFormId = "196aef85-cb0b-4cb2-bbb6-635c6eb05c00";

const ContactForm = ({
  formProps,
  inputProps,
  handleChange,
  handleSubmit,
  isValid,
  isSubmitting,
  t,
  values,
  submitted,
}) => {

  const [focused, setFocused] = useState(false)

  return (
    <Form onSubmit={handleSubmit} {...formProps} flex={1} mt={1}>
      <Flex
        style={{ position: "relative" }}
        justify="center"
        align="center"
        flex={1}
      >
        <Input
          placeholder={t("footer.contact.placeholder", {
            defaultValue: 'Enter your email'
          })}
          onChange={handleChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          value={values.email}
          name="email"
          autoFocus={true}
          displayProps={{
            mb: 0,
          }}
          pr={120}
          pb={1}
          pt={1}
          fontSize={2}
          height={44}
          disabled={submitted}
          color={submitted ? '#fff' : undefined}
          renderRightIcon={({ style }) => {
            const disabled = isSubmitting || !isValid;
            return (
              <Flex {...style} right={submitted ? style.right : 2}>
                {submitted ?
                  <CompleteIcon size={24} color={colors.white} flex={1} />
                  : <Button
                    bg="orange"
                    title={t('footer.contact.submitButton', {
                      defaultValue: 'Subscribe'
                    })}
                    style={{
                      opacity: ((focused || values.email) && disabled) ? 0.75 : 1
                    }}
                    disabled={disabled}
                    height={40}
                    px={2}
                    py={1}
                    onClick={handleSubmit} />}
              </Flex>
            );
          }}

          {...inputProps} />
      </Flex>
    </Form>
  );
};

const enhance = compose(
  translate("translations"),
  withFormik({
    mapPropsToValues: () => ({ email: "" }),
    validate: (values) => {
      return validate(values, {
        email: {
          presence: true,
          email: true
        }
      }) || {};
    },
    isInitialValid: false,
    validateOnChange: true,
    handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
      try {

        const response = await fetch(subscriptionUrl, {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          mode: 'cors',
          body: qs.stringify({
            data: JSON.stringify({
              "emailaddr_": [values.email],
              demographics: ["emailaddr_"],
              list: ["fcfcu"],
              categories: ["[]"],
              mailid: [""],
              p: [subscriptionFormId],
              m: [""],
              keyword: [""],
              save: [""]
            })
          })
        })

        const responseData = await response.json();

        if (responseData && responseData.Errors) {
          alert(responseData.Errors);
          return;
        }
        props.onSubmitComplete()
      } catch (e) {
        console.warn("error", e);
        if (Array.isArray(e)) {
          setErrors({
            _form: e,
          });
        }
      } finally {
        setSubmitting(false);
      }
    },
  }),
);

export default enhance(ContactForm);



// WEBPACK FOOTER //
// ./src/components/Layout/ContactForm.js